import React from "react";
import { MapPin, Phone, Clock, Navigation, MessageCircle } from "lucide-react";
import { brand } from "../mock";

export default function Location() {
  return (
    <section id="location" className="section-cream py-20 md:py-24 relative overflow-hidden">
      <div className="blob blob-yellow w-80 h-80 -top-20 -left-20" />
      <div className="blob blob-cyan w-72 h-72 bottom-0 -right-10" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="max-w-2xl">
          <div className="text-[#B45309] text-xs font-black tracking-[0.3em] uppercase">Visit Us</div>
          <h2 className="section-title mt-3 text-4xl md:text-5xl font-black brand-navy">
            Find us in <span className="gold-gradient">Vizianagaram</span>
          </h2>
          <p className="mt-4 text-[#0A1740]/70">
            Walk in, meet our trainers, tour the campus and book your free demo class – we’re right next to Winway School.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-5 gap-6">
          {/* Map */}
          <div className="lg:col-span-3 rounded-3xl overflow-hidden border border-[#0A1740]/10 shadow-xl bg-white">
            <iframe
              title="CYA Youth Academy Vizianagaram – Location Map"
              src={brand.mapEmbed}
              width="100%"
              height="460"
              style={{ border: 0, display: "block" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>

          {/* Details */}
          <div className="lg:col-span-2 space-y-4">
            <div className="rounded-2xl bg-white border border-[#0A1740]/10 p-5 shadow-sm">
              <div className="flex items-start gap-3">
                <div className="w-11 h-11 shrink-0 rounded-xl bg-[#FEF3C7] border border-[#F59E0B]/40 flex items-center justify-center text-[#B45309]">
                  <MapPin size={18} />
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-widest text-[#0A1740]/55 font-bold">Address</div>
                  <div className="brand-navy font-bold text-sm mt-1 leading-relaxed">
                    CYA Youth Academy<br />
                    {brand.address}
                  </div>
                </div>
              </div>
              <a
                href={brand.mapDirections}
                target="_blank"
                rel="noreferrer"
                className="mt-4 inline-flex items-center gap-2 text-[#B45309] font-bold text-sm hover:text-[#F59E0B]"
              >
                <Navigation size={16} /> Get Directions
              </a>
            </div>

            <div className="rounded-2xl bg-white border border-[#0A1740]/10 p-5 shadow-sm">
              <div className="flex items-start gap-3">
                <div className="w-11 h-11 shrink-0 rounded-xl bg-[#FCE7F3] border border-[#EC4899]/40 flex items-center justify-center text-[#BE185D]">
                  <Clock size={18} />
                </div>
                <div className="flex-1">
                  <div className="text-[11px] uppercase tracking-widest text-[#0A1740]/55 font-bold">Timings</div>
                  <ul className="mt-2 text-sm brand-navy space-y-1">
                    {brand.hours.map((h) => (
                      <li key={h.day} className="flex items-center justify-between gap-4">
                        <span className="font-semibold">{h.day}</span>
                        <span className="text-[#0A1740]/70">{h.time}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <a
                href={brand.phoneDial}
                className="rounded-2xl bg-white border border-[#0A1740]/10 p-4 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 rounded-xl bg-[#E0E7FF] border border-[#818CF8]/40 flex items-center justify-center text-[#4338CA]">
                  <Phone size={16} />
                </div>
                <div className="text-[10px] uppercase tracking-widest text-[#0A1740]/55 font-bold mt-3">Call</div>
                <div className="brand-navy font-extrabold text-sm">{brand.phone}</div>
              </a>
              <a
                href={brand.whatsapp}
                target="_blank"
                rel="noreferrer"
                className="rounded-2xl bg-white border border-[#0A1740]/10 p-4 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 rounded-xl bg-[#DCFCE7] border border-[#22C55E]/40 flex items-center justify-center text-[#166534]">
                  <MessageCircle size={16} />
                </div>
                <div className="text-[10px] uppercase tracking-widest text-[#0A1740]/55 font-bold mt-3">WhatsApp</div>
                <div className="brand-navy font-extrabold text-sm">Chat now</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
